import { SG_EVENT_NAMES } from '@/utils/tools/segment/eventNames';
import { trackEvent } from '@/utils/tools/segment/tracking';
import { Button, Dropdown, Flex, Typography, Upload } from 'antd';
import axios from 'axios';
import { useSession } from 'next-auth/react';
import { useContext, useState } from 'react';
import { LibraryContext } from './context-provider';
import NewFolderModal from './modal-new-folder';
const { Text } = Typography;

export default function NewButton({ parentFolder, ...props }) {
   const [openNewFolderModal, setOpenNewFolderModal] = useState(false);
   const { library, uploadFileList, setUploadFileList } = useContext(LibraryContext);
   const session = useSession();

   const newDropdownMenu = [
      {
         key: '1',
         label: (
            <Flex gap={16} align="center">
               <i className="fi fi-rr-add-folder" />
               <Text>New Folder</Text>
            </Flex>
         ),
         onClick: () => setOpenNewFolderModal(true),
      },
      {
         type: 'divider',
      },
      {
         key: '2',
         label: (
            <Upload
               showUploadList={false}
               fileList={uploadFileList}
               action={`/api/upload?path=library/${session?.data?.user?.id}`}
               accept=".jpg,.jpeg,.png,.gif,.ppt,.pptx"
               onSuccess={async (response,file) => {
                  if (file.status !== 'done') {
                     file.status = 'done';
                     setUploadFileList([...uploadFileList , file]);
                     const res = await axios.post('/api/library/file', {
                        name: file.name,
                        fileId: response.id,
                        parentFolderId: parentFolder,
                     });
                     // check if response is ok
                     if (res.status === 200) {
                        // update folder to show new file
                        library.mutate();
                        // track event
                        trackEvent(SG_EVENT_NAMES.USER_UPLOAD_LIBRARY_FILE);
                     }
                  }
                     
                }}
            >
               <Flex gap={16} align="center">
                  <i className="fi fi-rr-file-upload" />
                  <Text>Upload File</Text>
               </Flex>
            </Upload>
         ),
      },
   ];

   return (
      <>
         <NewFolderModal
            open={openNewFolderModal}
            setOpen={setOpenNewFolderModal}
            parentFolder={parentFolder}
            library={library}
            {...props?.modalProps}
         />

         <Dropdown trigger={['click']} menu={{ items: newDropdownMenu }}>
            <Button type="primary" icon={<i className="fi fi-rr-plus" />} {...props?.buttonProps}>
               New
               <i className="fi fi-rr-angle-small-down" />
            </Button>
         </Dropdown>
      </>
   );
}
